import { configQuery } from '@gig/magic-common';
import { GAMES_SET_CURRENT_GAME_SLUG, GAMES_CURRENT_GAME_SLUG_UPDATED, GAMES_FETCH, USER_LOGGED_IN_UPDATED, GAMES_CURRENT_GAME_UPDATED, IP_COUNTRY_QUERY, GAMES_LIST, GAMES_LIST_QUERY, GAMES_PROVIDERS, GAMES_LOADED, GAMES_SCROLL_DOWN, GAMES_CATEGORIES_LIST, GAMES_JACKPOTS_LIST, GAMES_RECOMMENDED_GAMES, GAMES_RECOMMENDED_GAMES_USER } from '@gig/magic-messages';
import { filterChildishGames, filterAuthRequiredGames } from './filter-games.js';

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
class GamesService {
  constructor() {
    this.games = null;
    this.isLoggedIn = false;
    this.currentGameSlug = null;
    this.subscription = null;
    this.registerHandlers();
    this.subscribeToGamesFetch();
    this.subscribeToCurrentGameChanges();
  }
  subscribeToCurrentGameChanges() {
    window.commandBus.subscribe(GAMES_SET_CURRENT_GAME_SLUG, (event) => {
      this.currentGameSlug = event.payload;
      window.eventBus.publish(GAMES_CURRENT_GAME_SLUG_UPDATED, this.currentGameSlug);
      this.updateCurrentGame();
    });
  }
  subscribeToGamesFetch() {
    window.eventBus.subscribe([GAMES_FETCH, USER_LOGGED_IN_UPDATED], (event) => __async(this, null, function* () {
      const [games, isLoggedIn] = event.payload;
      this.unsubscribeQuery();
      this.games = games;
      this.isLoggedIn = isLoggedIn;
      this.updateCurrentGame();
      yield this.updateGameList();
      this.registerQueryHandler();
    }), { replay: true });
  }
  updateCurrentGame() {
    if (!this.games || !this.currentGameSlug) {
      window.eventBus.publish(GAMES_CURRENT_GAME_UPDATED, null);
      return;
    }
    const game = this.games.get(this.currentGameSlug);
    window.eventBus.publish(GAMES_CURRENT_GAME_UPDATED, game);
  }
  updateGameList() {
    return __async(this, null, function* () {
      var _a;
      const ipCountry = yield window.queryBus.query(IP_COUNTRY_QUERY);
      const lockCountries = (_a = yield configQuery("countries.childLockCountries")) != null ? _a : [];
      const isChildLockCountry = !!ipCountry && lockCountries.includes(ipCountry);
      if (!this.isLoggedIn && isChildLockCountry) {
        window.eventBus.publish(GAMES_LIST, filterChildishGames(this.games));
      } else if (!this.isLoggedIn) {
        window.eventBus.publish(GAMES_LIST, filterAuthRequiredGames(this.games));
      } else {
        window.eventBus.publish(GAMES_LIST, this.games);
      }
    });
  }
  registerQueryHandler() {
    this.subscription = window.queryBus.subscribe(GAMES_LIST_QUERY, () => {
      return this.games;
    });
  }
  unsubscribeQuery() {
    var _a;
    (_a = this.subscription) == null ? void 0 : _a.unsubscribe();
    this.subscription = null;
  }
  registerHandlers() {
    window.eventBus.register(GAMES_PROVIDERS, {
      type: "array"
    });
    window.eventBus.register(GAMES_LOADED, {
      type: "boolean"
    });
    window.commandBus.register(GAMES_SCROLL_DOWN, {
      type: "null"
    });
    window.eventBus.register(GAMES_LIST, {
      type: "object"
    });
    window.eventBus.register(GAMES_CATEGORIES_LIST, {
      type: "array"
    });
    window.eventBus.register(GAMES_JACKPOTS_LIST, {
      type: "object"
    });
    window.eventBus.register(GAMES_RECOMMENDED_GAMES, {
      type: "array"
    });
    window.eventBus.register(GAMES_RECOMMENDED_GAMES_USER, {
      type: "array"
    });
  }
}

export { GamesService };
